import { PUBLIC_LEGAL_ORIGIN } from "./public-legal-links";

export function publicSiteUrl(path: "/pricing" | "/contact" | "/support" | "pricing" | "contact" | "support"): string {
  return `${PUBLIC_LEGAL_ORIGIN}/${path.replace(/^\//, "")}`;
}
